import { v1 as uuid } from 'uuid';

import { ANSWER_DEFAULT } from '../../constants';
import { MATRIX_CONVERSATIONAL_CELL_TYPES } from '../MatrixOpenEndedQuestion/constants';
import {
  ERROR_CODES_CONVERSATIONAL_MESSAGES,
  ERROR_CODES_CONVERSATIONAL,
} from './constants';

export const getAnswerObjective = (question = {}) => {
  const { matrix = {}, answers = [] } = question;
  const { answerColumnValueTypes = [] } = matrix;

  const targetAnswerColumn = answerColumnValueTypes.find(
    (answer) => answer.cellType === MATRIX_CONVERSATIONAL_CELL_TYPES.OBJECTIVE,
  );

  const targetAnswer = answers.find(
    (answer) => answer.refId === targetAnswerColumn?.answerRefId,
  );

  if (!targetAnswer) {
    return undefined;
  }

  return { ...targetAnswer };
};

export const getAnswerGoals = (question = {}) => {
  const { matrix = [], answers = [] } = question;
  const { answerColumnValueTypes = [] } = matrix;

  const targetAnswerColumn = answerColumnValueTypes.find(
    (answer) => answer.cellType === MATRIX_CONVERSATIONAL_CELL_TYPES.OBJECTIVE,
  );

  const targetAnswers = answers
    .filter((answer) => answer.refId !== targetAnswerColumn?.answerRefId)
    .map((answer) => ({ ...answer }));

  return targetAnswers;
};

export const getEmptyAnswer = (valid = false, cellType = null) => ({
  body: '',
  refId: uuid(),
  type: ANSWER_DEFAULT,
  isEmptyAnswer: !valid,
  cellType,
});

export const getEmptyMatrixAnswer = (answerRefId) => ({
  refId: uuid(),
  answerRefId,
  beforeLabel: '',
});

export const getAnswerColumnValueType = ({
  answerRefId,
  columnRefId,
  cellType,
}) => ({
  answerRefId,
  columnRefId,
  type: 1,
  cellType,
  isMandatory: false,
});

export const updateMatrixValues = ({
  matrixAnswers,
  answerColumnValueTypes,
  answerRefId,
  columnRefId,
  actionType,
  cellType,
}) => {
  const updatedMatrixAnswers = [...matrixAnswers];
  const updatedAnswerColumnValueTypes = [...answerColumnValueTypes];

  if (actionType === 'update') {
    const targetMatrixAnswer = matrixAnswers.find(
      (matrixAnswer) => matrixAnswer.answerRefId === answerRefId,
    );
    if (!targetMatrixAnswer) {
      updatedMatrixAnswers.push(getEmptyMatrixAnswer(answerRefId));
      updatedAnswerColumnValueTypes.push(
        getAnswerColumnValueType({
          answerRefId,
          columnRefId,
          cellType,
        }),
      );
    }
  } else if (actionType === 'remove') {
    const targetMatrixAnswerIndex = matrixAnswers.findIndex(
      (matrixAnswer) => matrixAnswer.answerRefId === answerRefId,
    );
    if (targetMatrixAnswerIndex !== -1) {
      updatedMatrixAnswers.splice(targetMatrixAnswerIndex, 1);
    }

    const targetAnswerColumnValueTypeIndex = answerColumnValueTypes.findIndex(
      (answerColumnValueType) =>
        answerColumnValueType.answerRefId === answerRefId &&
        answerColumnValueType.columnRefId === columnRefId,
    );

    if (targetAnswerColumnValueTypeIndex !== -1) {
      updatedAnswerColumnValueTypes.splice(targetAnswerColumnValueTypeIndex, 1);
    }
  }

  return {
    matrixAnswers: updatedMatrixAnswers,
    answerColumnValueTypes: updatedAnswerColumnValueTypes,
  };
};

export const getObjectiveErrorMsg = (errors) => {
  if (errors[ERROR_CODES_CONVERSATIONAL.objectiveEmpty]) {
    return ERROR_CODES_CONVERSATIONAL_MESSAGES[
      ERROR_CODES_CONVERSATIONAL.objectiveEmpty
    ];
  }

  if (errors[ERROR_CODES_CONVERSATIONAL.objectiveTooLong]) {
    return ERROR_CODES_CONVERSATIONAL_MESSAGES[
      ERROR_CODES_CONVERSATIONAL.objectiveTooLong
    ];
  }

  return undefined;
};

export const getGoalErrorMsg = (errors) => {
  if (errors[ERROR_CODES_CONVERSATIONAL.goalEmpty]) {
    return ERROR_CODES_CONVERSATIONAL_MESSAGES[
      ERROR_CODES_CONVERSATIONAL.goalEmpty
    ];
  }
  if (errors[ERROR_CODES_CONVERSATIONAL.goalTooLong]) {
    return ERROR_CODES_CONVERSATIONAL_MESSAGES[
      ERROR_CODES_CONVERSATIONAL.goalTooLong
    ];
  }

  return undefined;
};

export const cleanEmptyGoalAnswers = (goalAnswers) => {
  const filteredAnswers = goalAnswers.filter((answer) => !answer.isEmptyAnswer);
  if (filteredAnswers.length === 0) {
    if (goalAnswers.length > 0) {
      return goalAnswers;
      // return [goalAnswers[0]];
    }
    return [];
  }

  return filteredAnswers;
};

export const insertEmptyGoalAnswer = (answers) => {
  const updatedAnswers = [...answers];
  const emptyAnswer = getEmptyAnswer(
    false,
    MATRIX_CONVERSATIONAL_CELL_TYPES.GOAL,
  );
  updatedAnswers.push(emptyAnswer);
  return { updatedAnswers, emptyAnswer };
};

export const getGoalAnswerId = (refId) => `goal-answer-${refId}`;

export const hasEmptyAnswer = (answers = []) =>
  answers.filter((answer) => answer.isEmptyAnswer).length > 0;
